import Button from 'common/components/Elements/Button/Button';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import { startCommand } from 'core/redux/actions/command/commandActions';
import type { AppDispatch } from 'core/redux/store/configureStore.types';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React from 'react';
import { useDispatch } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandButton({ command, small }: ComponentProps) {
  const {
    id, title, active, label, action,
  } = command;
  const dispatch = useDispatch<AppDispatch>();
  return (
    <Button
      action={action || 'tertiary'}
      className={classes.command}
      title={title}
      onClick={() => dispatch(startCommand(command))}
      small={small}
      disabled={active === false}
      e2eId={id}
      buttonIcon={label === undefined}
    >
      <CommandLinkContent command={command} />
    </Button>
  );
}

export default CommandButton;
